import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useEffect } from "react";
import { toast } from "sonner";
import { getPeriodStart } from "./utils/dateUtils";
import { fetchLosses } from "./utils/lossUtils";
import { fetchTransactions } from "./utils/transactionUtils";

export const useTransactions = (transactionType?: string, period: string = "all") => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel('transaction-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: transactionType === 'loss' ? 'stock_losses' : 'poultry_transactions'
        },
        () => {
          console.log('Transaction change detected, invalidating query...');
          queryClient.invalidateQueries({ queryKey: ['transactions', transactionType, period] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient, transactionType, period]);

  return useQuery({
    queryKey: ['transactions', transactionType, period],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      console.log('Fetching transactions with filters:', { transactionType, period });

      const periodStart = getPeriodStart(period);
      console.log('Period start date:', periodStart);

      if (transactionType === "loss") {
        return fetchLosses(supabase, periodStart);
      } else {
        return fetchTransactions(supabase, periodStart, transactionType);
      }
    },
  });
};